/* (ignored) */


//////////////////
// WEBPACK FOOTER
// intl/locale-data/complete.js (ignored)
// module id = 8
// module chunks = polyfills